import { styled, Box, Typography, Stack } from "@mui/material";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";

export const CardContainer = styled(Box)({
  padding: "16px",
  borderRadius: "8px",
  border: "1px solid #EEF1FF",
  background: "#fff"
});

export const SmallText = styled(Typography)<{
  color?: string;
}>(({ color }) => ({
  color: color || "#646D7B",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "132%"
}));

export const InfoIcon = styled(InfoRoundedIcon)({
  width: "16px",
  height: "16px",
  color: "#959EB2"
});

export const ObjectDetailsLeftContainer = styled(Stack)(({ theme }) => ({
  maxHeight: "calc(100vh - 140px)",
  overflowY: "scroll",
  scrollBehavior: "smooth",

  // uncomment it if we don't need scrollbar in the Left Panel
  // ["::-webkit-scrollbar"]: {
  //   width: "8px" /* Remove scrollbar space */,
  //   background: "lightgray" /* Optional: just make scrollbar invisible */
  // },
  // Hide scrollbar for Chrome, Safari and Opera
  "&::-webkit-scrollbar": {
    display: "none"
  },

  // Hide scrollbar for IE, Edge and Firefox
  "-ms-overflow-style": "none",
  scrollbarWidth: "none",

  [theme.breakpoints.down("md")]: {
    maxHeight: "none",
    overflowY: "hidden",
    marginBottom: "20px"
  }
}));
